import { render, staticRenderFns } from "./businessCenters.vue?vue&type=template&id=01f66ec2&scoped=true&"
import script from "./businessCenters.vue?vue&type=script&lang=js&"
export * from "./businessCenters.vue?vue&type=script&lang=js&"
import style0 from "./businessCenters.vue?vue&type=style&index=0&id=01f66ec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f66ec2",
  null
  
)

export default component.exports